import championsInfo from '../assets/riot/champion.json';
import findKey from 'lodash/findKey';

export const getChampionInfo = championId => {
  const championKey = findKey(championsInfo.data, champion => champion.key == championId);
  return championsInfo.data[championKey];
};
